import OwnerTextCTA from './OwnerTextCTA';
export default OwnerTextCTA;